import { Err, Ok } from "@siteimprove/alfa-result";
import { Diagnostic } from "@siteimprove/alfa-act";
export var RefreshDelay;
(function (RefreshDelay) {
    RefreshDelay.HasImmediateRefresh = Ok.of(Diagnostic.of(`The refresh or redirect happens immediately`));
    RefreshDelay.HasTwentyHoursDelayedRefresh = Ok.of(Diagnostic.of(`The refresh or redirect happens after 20 hours or more`));
    RefreshDelay.HasDelayedRefresh = Err.of(Diagnostic.of(`The refresh or redirect is delayed`));
})(RefreshDelay || (RefreshDelay = {}));
//# sourceMappingURL=refresh-delay.js.map